import { useLang } from "../../context/LanguageContext";
import {
  Users, IdCard, GitBranch, Store, BarChart3, FileBadge, Bot, Building2,
} from "lucide-react";

const ICONS = {
  experience: Users,
  workforce: IdCard,
  operations: GitBranch,
  commercial: Store,
  data: BarChart3,
  licensing: FileBadge,
  agents: Bot,
  industry: Building2,
};

export const SolutionPillars = () => {
  const { t } = useLang();
  return (
    <section id="solutions" data-testid="solutions-section" className="py-24 lg:py-32 border-b border-[#0B1F3A]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#D4AF37]" />
              <span className="overline">{t.pillars.eyebrow}</span>
            </div>
            <h2 className="font-display text-3xl lg:text-4xl font-light text-[#0B1F3A] leading-tight tracking-tight">
              {t.pillars.title}
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-[#0B1F3A]/70 text-base lg:text-lg leading-relaxed">{t.pillars.sub}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-[#0B1F3A]/15">
          {t.pillars.items.map((item, idx) => {
            const Icon = ICONS[item.id] || Building2;
            return (
              <div
                key={item.id}
                data-testid={`pillar-${item.id}`}
                className="group relative p-7 lg:p-8 border-r border-b border-[#0B1F3A]/15 bg-white hover:bg-[#F8F9FA] transition-colors min-h-[260px] flex flex-col"
              >
                <div className="absolute top-3 right-4 text-[10px] tracking-widest text-[#0B1F3A]/30 font-mono">
                  {String(idx + 1).padStart(2, "0")}
                </div>
                <Icon size={22} strokeWidth={1.5} className="text-[#0B1F3A] group-hover:text-[#D4AF37] transition-colors" />
                <h3 className="mt-5 font-display text-lg font-semibold text-[#0B1F3A]">{item.name}</h3>
                <ul className="mt-4 space-y-1.5 text-[13px] text-[#0B1F3A]/70 leading-relaxed">
                  {item.points.map((p) => (
                    <li key={p} className="flex gap-2">
                      <span className="text-[#D4AF37] mt-1">·</span>
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
                <div className="absolute bottom-0 left-0 h-0.5 w-0 group-hover:w-full bg-[#D4AF37] transition-all duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
